import React, { useState, useEffect } from "react";
import { ethers } from "ethers";
import Sidebar from "./components/Sidebar";
import WalletConnect from "./components/WalletConnect";
import Overview from "./components/Overview";
import BuySell from "./components/BuySell";
import StakeActions from "./components/StakeActions";
import LoanActions from "./components/LoanActions";
import UserLoanActions from "./components/UserLoanActions";
import ValidatorList from "./components/ValidatorList";
import Transactions from "./components/Transactions";
import TransferActions from "./components/TransferActions";
import CUSD from "./components/CUSD";
import DEUS from "./components/DEUS";
import CrownDex from "./components/CrownDex";
import CrownGovernanceDao from "./components/CrownGovernanceDao";
import MyAccount from "./components/MyAccount";
import Dashboard from "./components/Dashboard";
import AddressContract from "./components/AddressContract";
import Lending from "./components/Lending";
import P2PTrading from "./components/P2PTrading"; // Added P2PTrading import
import "./App.css";

function App() {
  const [account, setAccount] = useState(null);
  const [provider, setProvider] = useState(null);
  const [activeSection, setActiveSection] = useState("overview");
  const [transactions, setTransactions] = useState([]);

  useEffect(() => {
    if (window.ethereum) {
      window.ethereum.on("accountsChanged", async (accounts) => {
        if (accounts.length > 0) {
          console.log("Account changed to:", accounts[0]);
          setAccount(accounts[0]);
          try {
            const browserProvider = new ethers.BrowserProvider(window.ethereum);
            setProvider(browserProvider);
          } catch (error) {
            console.error("Error setting provider on account change:", error.message);
            setProvider(null);
          }
        } else {
          console.log("No account connected.");
          setAccount(null);
          setProvider(null);
          setTransactions([]);
        }
      });

      window.ethereum.on("chainChanged", () => {
        console.log("Network changed, reloading page...");
        window.location.reload();
      });
    }

    return () => {
      if (window.ethereum) {
        window.ethereum.removeAllListeners("accountsChanged");
        window.ethereum.removeAllListeners("chainChanged");
      }
    };
  }, []);

  const handleTransaction = (transaction) => {
    setTransactions((prev) => [transaction, ...prev]);
  };

  const renderContent = () => {
    if (!account || !provider) {
      return <div>Please connect your wallet to continue.</div>;
    }

    switch (activeSection) {
      case "overview":
        return <Overview provider={provider} account={account} />;
      case "buySell":
        return <BuySell provider={provider} account={account} />;
      case "stake":
        return <StakeActions provider={provider} account={account} />;
      case "validators":
        return <ValidatorList provider={provider} account={account} />;
      case "loans":
        return <LoanActions provider={provider} account={account} />;
      case "userLoans":
        return <UserLoanActions provider={provider} account={account} />;
      case "transactions":
        return (
          <Transactions
            provider={provider}
            account={account}
            transactions={transactions}
            setTransactions={setTransactions}
          />
        );
      case "transfer":
        return <TransferActions provider={provider} account={account} />;
      case "cusd":
        return <CUSD provider={provider} account={account} />;
      case "deus":
        return (
          <DEUS
            provider={provider}
            account={account}
            onTransaction={handleTransaction}
          />
        );
      case "crowndex":
        return (
          <CrownDex
            provider={provider}
            account={account}
            onTransaction={handleTransaction}
          />
        );
      case "governance":
        return (
          <CrownGovernanceDao
            provider={provider}
            account={account}
            onTransaction={handleTransaction}
          />
        );
      case "myAccount":
        return <MyAccount provider={provider} account={account} />;
      case "dashboard":
        return <Dashboard provider={provider} account={account} />;
      case "addressContract":
        return <AddressContract provider={provider} account={account} />;
      case "lending":
        return (
          <Lending
            provider={provider}
            account={account}
            onTransaction={handleTransaction}
          />
        );
      case "p2p":
        return (
          <P2PTrading
            provider={provider}
            account={account}
            onTransaction={handleTransaction}
          />
        ); // Added P2PTrading rendering
      default:
        return <div>Select a section</div>;
    }
  };

  console.log("Current account in App.js:", account);

  return (
    <div className="App">
      <div className="header">
        <h1>👑 Crown DApp</h1>
        <Sidebar setActiveSection={setActiveSection} activeSection={activeSection} />
        <div className="wallet">
          <WalletConnect
            account={account}
            setAccount={setAccount}
            setProvider={setProvider}
          />
        </div>
      </div>
      <div className="container">
        <div className="main-content">{renderContent()}</div>
      </div>
    </div>
  );
}

export default App;